import React, { Component } from "react";
import ReactConfirmAlert from "react-confirm-alert"; // Import
import classes from "./styles.css";
import axios from "axios";
import { backendBaseUri } from "../../../uri";

class CompleteForms extends Component {
    state = {
        showDialog: false,
        itemToDelete: null,
    };

    onToggleDialog(id) {
        this.setState({
            showDialog: !this.state.showDialog,
        });
        if (id) {
            this.setState({
                itemToDelete: id,
            });
        } else {
            return;
        }
    }

    deletePatientForm(id) {
        const { itemToDelete } = this.state;
        this.setState({
            showDialog: !this.state.showDialog,
        });

        let formIdToDelete = this.props.forms[itemToDelete]._id;

        axios
            .delete(`${backendBaseUri}/complete/${formIdToDelete}`, {
                headers: {
                    "x-auth": localStorage.getItem("token"),
                },
            })
            .then((res) => {
                console.log(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    render() {
        let formName = this.props.forms.map((form, index) => {
            return (
                <div key={index}>
                    <li id={index}>
                        <i
                            onClick={(e) => this.onToggleDialog(e.target.id)}
                            id={index}
                            className="fa fa-times"
                            style={{ color: "red", marginRight: 10 }}
                        />
                        {form.completedFormName}
                    </li>
                </div>
            );
        });
        return (
            <div className={classes.List}>
                <ul>{formName}</ul>
                {this.state.showDialog ? (
                    <div className={classes.alertPopup}>
                        <ReactConfirmAlert
                            title="Are you sure to delete this patient's consent form?"
                            message=""
                            confirmLabel="Yes"
                            cancelLabel="No"
                            onConfirm={() => this.deletePatientForm()}
                            onCancel={() => this.onToggleDialog()}
                        />
                    </div>
                ) : (
                    <div />
                )}
            </div>
        );
    }
}

export default CompleteForms;



// WEBPACK FOOTER //
// ./src/components/Forms/CompleteForms/CompleteForms.js